export default __webpack_public_path__ + "static/media/contactus.4524d936.svg";